import { render, staticRenderFns } from "./MasterHoliday.vue?vue&type=template&id=2386e178&scoped=true&lang=pug&"
import script from "./scripts/MasterHoliday.js?vue&type=script&lang=js&"
export * from "./scripts/MasterHoliday.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386e178",
  null
  
)

export default component.exports